import { createElement } from 'react';
import { CustomAction as CustomActionType } from './types';

interface CustomActionProps {
    action: CustomActionType;
    component: React.ElementType;
}

export const CustomAction = ({ action, component }: CustomActionProps) => {
    const handleClick = action.onClick;

    return createElement(component, {
        title: action.text,
        icon: action.icon,
        onClick: handleClick,
        disabled: action.disabled,
    });
};
